import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { usuarioSelector, instalacionSelector } from '../../selectors/sessionSelector'
import { calendariosTurneroSelector } from '../../selectors/turneroSelector'
import * as sessionActions from '../../reducers/sessionReducer/actions'
import * as configuracionesActions from '../../reducers/configuracionesReducer/actions'
import Configuraciones from '../../components/Configuraciones'
import * as Notification from '../../components/Common/notification'

const modalidad = {
    Pickup: 1,
    Delivery: 2
}

const configuracionOptions = {
    Precios: 1,
    CobroDelivery: 2,
    TurneroPickupCantDias: 3,
    TurneroPickupTurnos: 4,
    DiasNoLaborablesPickup: 5,
    TurneroDeliveryCantDias: 6,
    TurneroDeliveryTurnos: 7,
    DiasNoLaborablesDelivery: 8,
    SupervisorPicking: 9
}

class ConfiguracionesContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            usuarioCargado: false,
            instalacionCargada: false,
            turneroCargado:this.props.instalacion ? true : false,
            openModal: false,
            showSeccionPrincipal: true,
            calendarioEdit: undefined,

            itemAEditar: undefined,
            esNoLaborable: false,

            nuevoMontoMinimo: undefined,
            errorCompraMinima: undefined,
            infoDiasNoLaborablesPickup: undefined,
            infoDiasNoLaborablesDelivery: undefined,

            checkBoxCobrarEntrega: true,
            nuevoMontoDelivery: undefined,

            nuevaCantDiasHabilitadosPickup: '',
            nuevaCantDiasHabilitadosDelivery: '',
            cantDiasHabilitadosPickup: '',
            cantDiasHabilitadosDelivery: '',
            errores: {},
            
            usuario: this.props.usuario,
            oldPassword: '',
            newPassword: '',
            retypeNewPassword: '',
        }

        if(this.props.instalacion){
            this.props.sagaGetCalendariosTurnero({idInstalacion: this.props.instalacion.id})
        }
    }

    componentDidUpdate = () => {
        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                } 
            })
        }

        if(this.props.instalacion !== undefined && this.state.turneroCargado === false && this.props.calendariosTurnero === undefined){
            this.setState({
                turneroCargado: true,
            }, () => {
                this.props.sagaGetCalendariosTurnero({idInstalacion: this.props.instalacion.id})
            })
        }

        if(this.state.instalacionCargada === false && this.props.instalacion !== undefined){
            
            let nuevoMontoMinimo = this.props.instalacion && this.props.instalacion.montoCompraMinimoPermitido !== undefined ? this.props.instalacion.montoCompraMinimoPermitido : undefined
            let checkBoxCobrarEntrega = this.props.instalacion && this.props.instalacion.cobroDelivery !== undefined ? this.props.instalacion.cobroDelivery : true
            let nuevoMontoDelivery = this.props.instalacion && this.props.instalacion.montoDelivery !== undefined ? this.props.instalacion.montoDelivery : undefined 

            this.setState({
                instalacionCargada: true,
                nuevoMontoMinimo: nuevoMontoMinimo,
                checkBoxCobrarEntrega: checkBoxCobrarEntrega,
                nuevoMontoDelivery: nuevoMontoDelivery,
            })
        }

    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.instalacion !== this.props.instalacion ){
            let nuevoMontoMinimo = nextProps.instalacion && nextProps.instalacion.montoCompraMinimoPermitido !== undefined ? nextProps.instalacion.montoCompraMinimoPermitido : undefined
            let checkBoxCobrarEntrega = nextProps.instalacion && nextProps.instalacion.cobroDelivery !== undefined ? nextProps.instalacion.cobroDelivery : true
            let nuevoMontoDelivery = nextProps.instalacion && nextProps.instalacion.montoDelivery !== undefined ? nextProps.instalacion.montoDelivery : undefined 

            this.setState({
                instalacionCargada: true,
                nuevoMontoMinimo: nuevoMontoMinimo,
                checkBoxCobrarEntrega: checkBoxCobrarEntrega,
                nuevoMontoDelivery: nuevoMontoDelivery,
            })
        }

        if(nextProps.calendariosTurnero !== this.props.calendariosTurnero ){
            let tipoCalendarioPickup = nextProps.calendariosTurnero && nextProps.calendariosTurnero.length > 0 ? nextProps.calendariosTurnero.find(x => x.idTipoCalendario === modalidad.Pickup) : undefined
            let cantDiasHabilitadosPickup = undefined
            let infoDiasNoLaborablesPickup = undefined
            if(tipoCalendarioPickup){
                cantDiasHabilitadosPickup = tipoCalendarioPickup.diasAdelante
                infoDiasNoLaborablesPickup = tipoCalendarioPickup.infoDiasNoLaborable
            }

            let tipoCalendarioDelivery = nextProps.calendariosTurnero && nextProps.calendariosTurnero.length > 0 ? nextProps.calendariosTurnero.find(x => x.idTipoCalendario === modalidad.Delivery) : undefined
            let cantDiasHabilitadosDelivery = undefined
            let infoDiasNoLaborablesDelivery = undefined
            if(tipoCalendarioDelivery){
                cantDiasHabilitadosDelivery = tipoCalendarioDelivery.diasAdelante
                infoDiasNoLaborablesDelivery = tipoCalendarioDelivery.infoDiasNoLaborable
            }

            this.setState({
                cantDiasHabilitadosPickup: cantDiasHabilitadosPickup,
                cantDiasHabilitadosDelivery: cantDiasHabilitadosDelivery,
                infoDiasNoLaborablesPickup: infoDiasNoLaborablesPickup,
                infoDiasNoLaborablesDelivery: infoDiasNoLaborablesDelivery
            })
        }
    }

    handleOnClickEditar = (itemAEditar) => {
        let value = !this.state.openModal

        let showSeccionPrincipal = this.state.showSeccionPrincipal
        let calendarioEdit = this.state.calendarioEdit
        let esNoLaborable = false
        
        if(itemAEditar === configuracionOptions.TurneroPickupTurnos || itemAEditar === configuracionOptions.TurneroDeliveryTurnos){
            showSeccionPrincipal = false
            let idTipoCalendario = itemAEditar === configuracionOptions.TurneroPickupTurnos ? modalidad.Pickup : modalidad.Delivery
            if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendario === idTipoCalendario)
            }
            value = false
        }

        if(itemAEditar === configuracionOptions.DiasNoLaborablesPickup || itemAEditar === configuracionOptions.DiasNoLaborablesDelivery){
            showSeccionPrincipal = false
            let idTipoCalendario = itemAEditar === configuracionOptions.DiasNoLaborablesPickup ? modalidad.Pickup : modalidad.Delivery
            if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendario === idTipoCalendario)
            }
            value = false
            esNoLaborable = true
        }
        
        
        this.setState({
            openModal: value, 
            itemAEditar: itemAEditar, 
            showSeccionPrincipal:showSeccionPrincipal,
            calendarioEdit: calendarioEdit,
            esNoLaborable: esNoLaborable,
            retypeNewPassword: undefined, 
            newPassword: undefined, 
            oldPassword: undefined 
        })
    }

    handleOnChangeMonto = (e, name) => {
        let value = undefined
        if (Number.isNaN(e.floatValue)) {
                value = e.value
            }
            else { 
          value = e.floatValue
        }
        
        this.setState({[name]: value})
    }  

    handleOnClickGuardar = () => {
        
        let configuracion = this.state.itemAEditar

        switch(configuracion){
            case configuracionOptions.Precios:{
                if(this.state.nuevoMontoMinimo === undefined || this.state.nuevoMontoMinimo === null || this.state.nuevoMontoMinimo === ""){
                    this.setState({errorCompraMinima: "Ingrese un monto"})
                    return
                }

                let payload = {
                    monto: this.state.nuevoMontoMinimo,
                    idInstalacion: this.props.instalacion ? this.props.instalacion.id : undefined,
                }

                this.setState({openModal: false, nuevoMontoMinimo: undefined}, () => {
                    this.props.sagaSetMontoCompraMinima(payload)
                })
                break
            }
            case configuracionOptions.CobroDelivery: {
                if(this.state.nuevoMontoDelivery === undefined || this.state.nuevoMontoDelivery === null || this.state.nuevoMontoDelivery === ""){
                    this.setState({errorCompraMinima: "Ingrese un monto"})
                    return
                }

                let payload = {
                    monto: this.state.nuevoMontoDelivery,
                    cobroDelivery: this.state.checkBoxCobrarEntrega,
                    idInstalacion: this.props.instalacion ? this.props.instalacion.id : undefined,
                }

                this.setState({openModal: false, nuevoMontoDelivery: undefined}, () => {
                    this.props.sagaSetConfiguracionDelivery(payload)
                })
                break
            }
            case configuracionOptions.TurneroPickupCantDias: {
                if(this.state.nuevaCantDiasHabilitadosPickup === undefined || this.state.nuevaCantDiasHabilitadosPickup === null || this.state.nuevaCantDiasHabilitadosPickup === ""){
                    let errores = {}
                    errores.nuevaCantDiasHabilitadosPickup = "Ingrese una cantidad"
                    this.setState({errores: errores})
                    return
                }

                let payload = {
                    cantidadDias: parseInt(this.state.nuevaCantDiasHabilitadosPickup),
                    modalidad: modalidad.Pickup,
                    idInstalacion: this.props.instalacion ? this.props.instalacion.id : undefined,
                }

                this.setState({openModal: false, nuevaCantDiasHabilitadosPickup: '', errores: {}, turneroCargado: false}, () => {
                    this.props.sagaSetConfiguracionTurnero(payload)
                })
                break
            }
            case configuracionOptions.TurneroDeliveryCantDias: {
                if(this.state.nuevaCantDiasHabilitadosDelivery === undefined || this.state.nuevaCantDiasHabilitadosDelivery === null || this.state.nuevaCantDiasHabilitadosDelivery === ""){
                    let errores = {}
                    errores.nuevaCantDiasHabilitadosDelivery = "Ingrese una cantidad"
                    this.setState({errores: errores})
                    return
                }

                let payload = {
                    cantidadDias: parseInt(this.state.nuevaCantDiasHabilitadosDelivery),
                    modalidad: modalidad.Delivery,
                    idInstalacion: this.props.instalacion ? this.props.instalacion.id : undefined,
                }

                this.setState({openModal: false, nuevaCantDiasHabilitadosDelivery: '', errores: {}, turneroCargado: false}, () => {
                    this.props.sagaSetConfiguracionTurnero(payload)
                })
                break
            }
            case configuracionOptions.SupervisorPicking:{
                let inputs = [this.state.oldPassword, this.state.newPassword, this.state.retypeNewPassword];
                
                if(inputs.some((e)=> e.trim().length === 0 )){
                    let errores = {}
                    errores.inputsIncompletos = "Todos los campos son requeridos"
                    this.setState({errores: errores})
                    return
                }

                if(this.state.newPassword !== this.state.retypeNewPassword) {
                    let errores = {}
                    errores.clavesNoCoinciden = "Las claves ingresadas no coinciden"
                    this.setState({errores: errores})
                    return
                }
                           
                let payload = {
                    oldPassword: this.state.oldPassword,
                    newPassword: this.state.newPassword
                }
                this.props.setNewClaveSupervisor(payload)
                this.setState({openModal: false, retypeNewPassword: undefined, newPassword: undefined, oldPassword: undefined })
                break
            }
        }
    }

    handleOnChange = (e) => {
        let value = e.target.value
        let name = e.target.name
        
        if((name === 'nuevaCantDiasHabilitadosPickup' || name === 'nuevaCantDiasHabilitadosDelivery') && value !== ""){
            var letterNumber = /^[0-9]+$/;
            if(value.length > 9 || !value.match(letterNumber)){
              return
            }
        }

        if(name === "checkBoxCobrarEntrega"){
            value = e.target.checked
        }

        this.setState({[name]: value})      
        
    }

    handleOnChangeInput = (e) => {
        let value = e.target.value
        let name = e.target.name
        
        this.setState({[name]: value})
    }

    handleOnBack = () => {
        this.setState({
            showSeccionPrincipal: true,
            esNoLaborable: false
        })
    }

    handleOnEliminarCalendarioHorario = (idCalendarioHorario) => {

        if(idCalendarioHorario === undefined || idCalendarioHorario === null){
            return
        }

        let payload = {}
        payload.idCalendarioHorario = idCalendarioHorario
        payload.idTipoCalendario = this.state.calendarioEdit ? this.state.calendarioEdit.idTipoCalendario : undefined
        payload.idInstalacion = this.props.instalacion ? this.props.instalacion.id : undefined

        payload.callback = () => {
            Notification.showSuccess("Horario eliminado con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if(itemAEditar === configuracionOptions.TurneroPickupTurnos || itemAEditar === configuracionOptions.TurneroDeliveryTurnos){
                let idTipoCalendario = itemAEditar === configuracionOptions.TurneroPickupTurnos ? modalidad.Pickup : modalidad.Delivery
                if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendario === idTipoCalendario)
                }
            }

            this.setState({calendarioEdit: calendarioEdit})
        } 

        this.setState({turneroCargado: false}, () => {
            this.props.sagaEliminarCalendarioHorario(payload)
        })
    }

    handleOnEliminarCalendarioNoLaborable = (idCalendarioNoLaborable) => {
        if(idCalendarioNoLaborable === undefined || idCalendarioNoLaborable === null){
            return
        }

        let payload = {}
        payload.idCalendarioNoLaborable = idCalendarioNoLaborable
        payload.idInstalacion = this.props.instalacion ? this.props.instalacion.id : undefined

        payload.callback = () => {
            Notification.showSuccess("Fecha eliminada con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if(itemAEditar === configuracionOptions.DiasNoLaborablesPickup || itemAEditar === configuracionOptions.DiasNoLaborablesDelivery){
                let idTipoCalendario = itemAEditar === configuracionOptions.DiasNoLaborablesPickup ? modalidad.Pickup : modalidad.Delivery
                if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendario === idTipoCalendario)
                }
            }

            this.setState({calendarioEdit: calendarioEdit})
        } 

        this.setState({turneroCargado: false}, () => {
            this.props.sagaEliminarCalendarioNoLaborable(payload)
        })
    }

    handleOnSaveTurno = (p) => {
        let payload = p
        payload.idInstalacion = this.props.instalacion ? this.props.instalacion.id : undefined

        payload.callback = () => {
            Notification.showSuccess("Horario guardado con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if(itemAEditar === configuracionOptions.TurneroPickupTurnos || itemAEditar === configuracionOptions.TurneroDeliveryTurnos){
                let idTipoCalendario = itemAEditar === configuracionOptions.TurneroPickupTurnos ? modalidad.Pickup : modalidad.Delivery
                if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendario === idTipoCalendario)
                }
            }

            this.setState({calendarioEdit: calendarioEdit})
        } 

        this.props.sagaSaveCalendarioHorario(payload)
    }

    handleOnSaveCalendarioNoLaborable = (p) => {
        let payload = p
        payload.idInstalacion = this.props.instalacion ? this.props.instalacion.id : undefined
        payload.idTipoCalendario = this.state.calendarioEdit ? this.state.calendarioEdit.idTipoCalendario : undefined
        payload.idRecurso = 1 // INDICA RECURSO DE SUCURSAL RECOLE !"HARDCODEADO"

        payload.callback = () => {
            Notification.showSuccess("Dia guardado con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if(itemAEditar === configuracionOptions.DiasNoLaborablesPickup || itemAEditar === configuracionOptions.DiasNoLaborablesDelivery){
                let idTipoCalendario = itemAEditar === configuracionOptions.DiasNoLaborablesPickup ? modalidad.Pickup : modalidad.Delivery
                if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendario === idTipoCalendario)
                }
            }

            this.setState({calendarioEdit: calendarioEdit})
        } 

        this.props.sagaSaveCalendarioNoLaborable(payload)
    }

    render() {
        return (
            <Configuraciones 
                itemAEditar={this.state.itemAEditar}
                errorCompraMinima={this.state.errorCompraMinima}
                openModal={this.state.openModal}
                showSeccionPrincipal={this.state.showSeccionPrincipal}
                nuevoMontoMinimo={this.state.nuevoMontoMinimo}
                nuevoMontoDelivery={this.state.nuevoMontoDelivery}
                infoDiasNoLaborablesPickup={this.state.infoDiasNoLaborablesPickup}
                infoDiasNoLaborablesDelivery={this.state.infoDiasNoLaborablesDelivery}
                checkBoxCobrarEntrega={this.state.checkBoxCobrarEntrega}
                nuevaCantDiasHabilitadosPickup={this.state.nuevaCantDiasHabilitadosPickup}
                nuevaCantDiasHabilitadosDelivery={this.state.nuevaCantDiasHabilitadosDelivery}
                cantDiasHabilitadosPickup={this.state.cantDiasHabilitadosPickup}
                cantDiasHabilitadosDelivery={this.state.cantDiasHabilitadosDelivery}
                calendarioEdit={this.state.calendarioEdit}
                esNoLaborable={this.state.esNoLaborable}
                errores={this.state.errores}
                handleOnClickEditar={this.handleOnClickEditar}
                handleOnChangeMonto={this.handleOnChangeMonto}
                handleOnClickGuardar={this.handleOnClickGuardar}
                handleOnChange={this.handleOnChange}
                handleOnBack={this.handleOnBack}
                handleOnSaveTurno={this.handleOnSaveTurno}
                handleOnEliminarCalendarioHorario={this.handleOnEliminarCalendarioHorario}
                handleOnEliminarCalendarioNoLaborable={this.handleOnEliminarCalendarioNoLaborable}
                handleOnSaveCalendarioNoLaborable={this.handleOnSaveCalendarioNoLaborable}
                montoCompraMinimo={this.props.instalacion ? this.props.instalacion.montoCompraMinimoPermitido : undefined}
                cobroDelivery={this.props.instalacion ? this.props.instalacion.cobroDelivery : undefined}
                montoDelivery={this.props.instalacion ? this.props.instalacion.montoDelivery : false}
                usuario={this.props.usuario}
                supervisorPicking={this.props.supervisorPicking}
                handleOnChangeInput={this.handleOnChangeInput}
                oldPassword={this.state.oldPassword}
                newPassword={this.state.newPassword}
                retypeNewPassword={this.state.retypeNewPassword}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...sessionActions,
        ...configuracionesActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuario: usuarioSelector(state),
        instalacion: instalacionSelector(state),
        calendariosTurnero: calendariosTurneroSelector(state)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracionesContainer)